import { Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';
import { RouteFallback } from './RouteFallback';
import { protectedRoutes, publicHomePage } from './routeConfig';
import { tokenService } from '../api/utils/tokenService';
import TermsScreen from "../components/terms/TermsScreen";

// 1. Import your mock data here (adjust path to where your file sits)
import { mockLandingData } from '../components/landing/mockLandingData';
import PrivacyScreen from '../components/Privacy Policy/PrivacyScreen';
import SignupScreen from '../components/signup/presentation/screens/SignupScreen';

export function AppRoutes() {
  const Home = publicHomePage;
  const token = tokenService.getAccessToken();

  // 2. Define a clean click handler to satisfy LandingProps
  const handleActionClick = (mode: string) => {
    console.log(`Action trigger from landing: ${mode}`);
    // Optional: add navigation logic here if needed (e.g., navigate('/login?mode=' + mode))
  };

  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        {/* 1. Root Path */}
        <Route
          path="/"
          element={
            token ? (
              <Navigate to="/profileStatus" replace />
            ) : (
              /* ✅ FIXED: Pass data and click handler props here */
              <Home data={mockLandingData} onActionClick={handleActionClick} isLoading={false} />
            )
          }
        />
        <Route
          path="/signin"
          element={<SignupScreen />}
        />
        <Route
          path="/terms"
          element={<TermsScreen />}
        />

        <Route
          path="/privacy"
          element={<PrivacyScreen />}
        />

        {/* 2. Protected Routes */}
        <Route element={<ProtectedRoute />}>
          {protectedRoutes.map(({ path, Page }) => (
            <Route key={path} path={path} element={<Page />} />
          ))}
        </Route>

        {/* 3. Catch-all */}
        <Route
          path="*"
          element={
            token ? (
              <Navigate to="/profileStatus" replace />
            ) : (
              /* ✅ FIXED: Pass data and click handler props here too */
              <Home data={mockLandingData} onActionClick={handleActionClick} isLoading={false} />
            )
          }
        />
      </Routes>
    </Suspense>
  );
}